import React from "react";
import { CHI_SIAMO } from "../../data/content";
import Reveal from "./Reveal";
import chisiamoImg from "../../assets/chisiamo.jpg";

export const ChiSiamo = () => (
  <section id="chi-siamo" data-testid="chi-siamo-section" className="bg-white py-20 md:py-32">
    <div className="mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-5">
        <Reveal>
          <p className="font-sub uppercase tracking-[0.3em] text-court font-bold text-sm mb-4">
            {CHI_SIAMO.kicker}
          </p>
          <h2 className="font-heading uppercase leading-[0.9] text-navy text-4xl md:text-6xl tracking-tight">
            {CHI_SIAMO.title}
          </h2>
        </Reveal>
        <div className="mt-8 space-y-5">
          {CHI_SIAMO.paragraphs.map((p, i) => (
            <Reveal key={i} delay={0.05 * i}>
              <p className="font-body text-base md:text-lg text-navy/75 leading-relaxed">{p}</p>
            </Reveal>
          ))}
        </div>

        <div className="mt-10 grid sm:grid-cols-3 gap-px bg-navy/15 border border-navy/15">
          {CHI_SIAMO.values.map((v, i) => (
            <Reveal key={v.t} delay={0.08 * i} className="bg-white">
              <div className="p-5" data-testid={`value-${v.t}`}>
                <div className="font-sub uppercase font-bold text-royal tracking-wide">{v.t}</div>
                <p className="font-body text-sm text-navy/60 mt-2">{v.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="lg:col-span-7">
        <Reveal y={60}>
          <div className="relative border-4 border-navy shadow-hard overflow-hidden">
            <img
              src={chisiamoImg}
              alt="Giovani atleti della Polisportiva Tricesimo in azione"
              className="w-full h-80 md:h-[560px] object-cover block"
              data-testid="chi-siamo-img-1"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default ChiSiamo;
